@if (loading) {
  <div class="position-relative" [ngStyle]="{ height: height ? height : 'auto' }">
    <ngx-spinner [fullScreen]="false" bdColor="rgba(51,51,51,0.0)" [color]="color" type="line-scale-pulse-out" [name]="spinnerName" size="small">
      @if (spinnerMessage) {
        <span class="loading d-block m-t-20">{{ spinnerMessage }}</span>
      }
    </ngx-spinner>
  </div>
}
